// language codes
export const LANG_CODE_ENGLISH = 'en';
export const LANG_CODE_VIETNAMESE = 'vi';

// a mapping of language codes to descriptive labels
export const LANG_CODE_LABELS = {
  [LANG_CODE_ENGLISH]: 'English',
  [LANG_CODE_VIETNAMESE]: 'Tiếng Việt',
};

// a simplistic translation table

const translations = {
  vi: {
    'Can you tell us why you gave these two ratings?':
      'Bạn có thể cho chúng tôi biết thêm lý do tại sao bạn lại đưa ra hai đánh giá này không?',
    Submit: 'Nộp',
    submit: 'nộp',
    'Select your response.': 'Chọn câu trả lời của bạn.',
    'Select your before response.': 'Chọn câu trả lời trước của bạn.',
    'Not at all': 'Không có gì',
    'Most imaginable': 'Có thể tưởng tượng nhất',
    Survey: 'Sự khảo sát',
    SURVEY: 'SỰ KHẢO SÁT',
    FOR: 'VÌ',
  },
};

export function _tr(txt, lang) {
  if (translations[lang] && translations[lang][txt]) {
    return translations[lang][txt];
  }
  return txt;
}

const i18n = {
  LANG_CODE_ENGLISH,
  LANG_CODE_VIETNAMESE,
  LANG_CODE_LABELS,
  _tr,
};

export default i18n;
